import React, { useEffect, useState } from "react";

import { SelectChangeEvent} from "@mui/material";
import Grid from "@mui/material/Grid2";

import { ContentView } from "./ContentView";
import { SportsView } from "./SportsView";
import { UsageView } from "./UsageView";
import { FilterBox } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult, TitleGenres } from "@/types";
import { filterScores } from "@/utils";

interface TvViewProps {
  scores: InsightResult[];
  lkp?: TitleGenres[];
}

export const TvView: React.FC<TvViewProps> = ({ scores, lkp }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [selectedGroup, setSelectedGroup] = useState<string>('');
  const [selectedScores, setSelectedScores] = useState<InsightResult[]>([]);
  const [minMax, setMinMax] = useState<number[]>([0, 1]);

  const scoreGroups = Array.from(
    new Set(scores.map(x => x.tag_group))
  ).sort().map(x => ({name: x, label: x}));

  useEffect(() => {
    setSelectedGroup('TV Content');
  }, []);

  useEffect(() => {
    setSelectedScores(filterScores(scores, selectedGroup, scoreType.value));
  }, [scores, selectedGroup, scoreType.value]);

  useEffect(() => {
    const maxScore = Math.max.apply(
      Math,
      selectedScores
        .filter((x) => x.tag_name !== x.tag_category)
        .map((x) => Number(x[scoreType.value as keyof InsightResult])),
    );
    const minScore =
      scoreType.value === "rate"
        ? Math.min.apply(
          Math,
          selectedScores
            .filter((x) => x.tag_name !== x.tag_category)
            .map((x) => Number(x[scoreType.value as keyof InsightResult])),
        )
        : Math.max(1 - (maxScore - 1), 0);

    setMinMax([minScore, maxScore])
  }, [selectedScores, scoreType])

  const handleGroupSelect = (e: SelectChangeEvent) => {
    setSelectedGroup(e.target.value);
  }

  return (
    <>
      <Grid container size={12} spacing={2}>

        <Grid size={12} pb={2}>
          <FilterBox
            label="Group"
            value={selectedGroup}
            options={scoreGroups}
            onChange={handleGroupSelect}
            showSelected
            width={300}
          />
        </Grid>

        {selectedGroup === 'TV Content' && (
          <ContentView scores={selectedScores} lkp={lkp}/>
        )}

        {selectedGroup === 'TV Usage' && (
          <UsageView scores={selectedScores}/>
        )}

        {selectedGroup === 'Sports Viewing Behaviours' && (
          <SportsView scores={selectedScores}/>
        )}
      </Grid>
    </>
  );
};

export default TvView;
